import type { StyleProps, SystemStyleObject } from "@ui/types";

export const styles = {
    form: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 14,
    },
    emailFormContainer: {
        alignItems: "flex-start",
        justifyContent: "space-between",
        bg: "black",
        gap: [2, 5, 5, 5],
        width: "100%",
        display: "flex",
        flexDirection: "row",
    },
    fieldStyle: {
        borderBottom: "3.4px solid white !important",
        borderTop: "0",
        borderLeft: "0",
        borderRight: "0",
        width: "115%",
        mb: 4,
        px: 0,
        py: 1,
        fontSize: ["mobileH1", "tabletH1"],
        fontWeight: "bold",
        height: "100% !important",
        color: "white",
        _placeholder: {
            color: "white",
            opacity: "100%",
        },
        bg: "black !important",
        _focusVisible: {
            borderColor: "unset",
        },
    },
    fieldErrorStyle: {
        borderBottom: "3.4px solid errorOnBlack !important",
        color: "errorOnBlack",
    },
    signUpButton: {
        maxHeight: "46px",
        mt: [0, 6],
        bg: "black !important",
    },
    formLabel: {
        color: "white",
    },
    formErrorMessage: {
        color: "errorOnBlack",
    },
} satisfies Record<string, StyleProps | SystemStyleObject>;
